module.exports = __webpack_public_path__ + "static/img/yanghua_4.82cc0509.png";